/**
 * @description Triggered to close Wallet Modal
 * @example
 * // Close Wallet Modal
 * window.caiEventBus.emit('wallet:close')
 *
 * // Listen
 * window.caiEventBus.on('wallet:close', function() { ... })
 */
export const CLOSE_WALLET = 'wallet:close';

export const OPEN_WALLET = 'wallet:open';

/**
 * a request event to get wallet payment information data
 */
export const WALLET_GET_PAYMENTS_INFORMATION_REQUEST = 'wallet:getPaymentsInformation:request';

/**
 * a completed event to Wallet Manager when wallet payment information data is retrieved
 */
export const WALLET_GET_PAYMENTS_INFORMATION_COMPLETED = 'wallet:getPaymentsInformation:completed';

/**
 * an event to check payments info is fetched/ready for use
 */
export const WALLET_ENSURE_PAYMENTS_INFO_REQUEST = 'wallet:ensurePaymentsInfo:request';

/**
 * an event sent by Wallet Manager when payments info is successfully fetched
 */
export const WALLET_ENSURE_PAYMENTS_INFO_COMPLETED = 'wallet:ensurePaymentsInfo:completed';

/**
 * requests Wallet Manager to reset consumer Id
 */
export const WALLET_UPDATE_DATA_AFTER_LOGIN_REQUEST = 'wallet:updateDataAfterLogin:request';

/**
 * requests Wallet Manager to reset consumer Id
 */
export const WALLET_UPDATE_DATA_AFTER_LOGIN_COMPLETE = 'wallet:updateDataAfterLogin:complete';

/**
 * requests Wallet Manager to reset consumer Id
 */
export const WALLET_RESET_CONSUMER_ID_REQUEST = 'wallet:resetConsumerId:request';

/**
 * requests Wallet Manager to fetch trade ins
 */
export const WALLET_GET_KBB_TRADE_INS_REQUEST = 'wallet:getTradeIns:request';

/**
 * an event sent by Wallet Manager when trade ins are successfully fetched
 */
export const WALLET_GET_KBB_TRADE_INS_COMPLETED = 'wallet:getTradeIns:completed';

/**
 * requests Wallet Manager to Wallet Storage with new Payments Info
 */
export const WALLET_UPDATE_WALLET_STORAGE_REQUEST = 'wallet:updateWalletStorage:request';

/**
 * an event sent by Wallet Manager when Wallet Storage is succefully updated
 */
export const WALLET_UPDATE_WALLET_STORAGE_COMPLETED = 'wallet:updateWalletStorage:completed';

/**
 * requests Wallet Manager to update Payments Info
 */
export const WALLET_UPDATE_PAYMENTS_INFO_REQUEST = 'wallet:updatePaymentsInfo:request';

/**
 * an event sent by Wallet Manager when Payments Info is updated
 */
export const WALLET_UPDATE_PAYMENTS_INFO_COMPLETED = 'wallet:updatePaymentsInfo:completed';

/**
 * requests Wallet Manager to get initialization status
 */
export const WALLET_GET_INITIALIZATION_STATUS_REQUEST = 'wallet:getInitializationStatus:request';

/**
 * an event sent by Wallet Manager when initialization status is retrieved
 */
export const WALLET_GET_INITIALIZATION_STATUS_COMPLETED = 'wallet:getInitializationStatus:completed';

/**
 * requests wallet manager to fetch ICO trade in data
 */
export const WALLET_GET_ICO_TRADE_INS_REQUEST = 'wallet:getICOTradeIns:request';

/**
 * an event sent by Wallet Manager when ICO Trade Ins fetch is completed
 */
export const WALLET_GET_ICO_TRADE_INS_COMPLETED = 'wallet:getICOTradeIns:completed';

/**
 * Send event to set the wallet error alert
 */
export const WALLET_SET_ERROR_ALERT_REQUEST = 'wallet:setErrorAlert:request';

/**
 * Listen for event to set the wallet error alert
 */
export const WALLET_SET_ERROR_ALERT_COMPLETED = 'wallet:setErrorAlert:completed';

/**
 * an requests wallet manager to open the SDP
 */
export const WALLET_OPEN_SDP_REQUEST = 'wallet:openSdp:request';

/**
 * an event sent by Wallet Manager when the open SDP event has completed
 */
export const WALLET_OPEN_SDP_COMPLETED = 'wallet:openSdp:completed';

/**
 * an event sent by Wallet Manager used to trigger analytics events for wallet sync activity
 */
export const WALLET_SYNC_OPEN = 'wallet:sync:open';

/**
 * an event sent by Wallet Manager used to trigger analytics events for wallet sync activity
 */
export const WALLET_SYNC_CONFIRM = 'wallet:sync:confirm';

/**
 * requests Wallet Manager to validate the deals by vin
 */
export const WALLET_VALIDATE_DEALS_BY_VIN_REQUEST = 'wallet:validateDealsByVin:request';

/**
 * requests Wallet Manager to validate the deals by vin
 */
export const WALLET_VALIDATE_DEALS_BY_VIN_COMPLETED = 'wallet:validateDealsByVin:completed';

/**
 * Requests a fetch for deal details
 */
export const WALLET_GET_DEAL_DETAILS_REQUEST = 'wallet:getDealDetails:request';

/**
 * Requests a fetch for deal details including a specific deal, polling to account for initial save latency
 */
export const WALLET_GET_DEAL_DETAILS_WITH_POLLING_REQUEST = 'wallet:getDealDetailsWithPolling:request';

/**
 * Announces deal details fetch has completed
 */
export const WALLET_GET_DEAL_DETAILS_COMPLETED = 'wallet:getDealDetails:completed';

/**
 * requests Wallet Manager to reset deal notifications
 */
export const WALLET_RESET_DEAL_NOTIFICATION_REQUEST = 'wallet:resetDealNotification:request';

/**
 * requests Wallet Manager to update a specific set of deal notifications
 */
export const WALLET_UPDATE_DEAL_NOTIFICATION_REQUEST = 'wallet:updateDealNotification:request';

/**
 * requests Wallet Manager to call the fetcher to get dealer information
 */
export const WALLET_GET_DEALS_WITH_DEALER_INFORMATION_REQUEST = 'wallet:getDealsWithDealerInformation:request';

/**
 * requests Wallet Manager to sent when dealer information are successfully fetched
 */
export const WALLET_GET_DEALS_WITH_DEALER_INFORMATION_COMPLETED = 'wallet:getDealsWithDealerInformation:completed';

/**
 * requests to open/trigger email dealer form
 */
export const WALLET_EMAIL_DEALER_REQUEST = 'wallet:emailDealer:request';

/**
 * events for payoff quote service
 */
export const WALLET_PAYOFF_QUOTE_SERVICE_GET_LENDERS_REQUEST = 'wallet:payoffQuoteService:getLenders:request';

export const WALLET_PAYOFF_QUOTE_SERVICE_GET_LENDERS_COMPLETED = 'wallet:payoffQuoteService:getLenders:completed';

export const WALLET_PAYOFF_QUOTE_SERVICE_GET_SELECTED_LENDER_REQUEST =
    'wallet:payoffQuoteService:getSelectedLender:request';

export const WALLET_PAYOFF_QUOTE_SERVICE_GET_SELECTED_LENDER_COMPLETED =
    'wallet:payoffQuoteService:getSelectedLender:completed';

export const WALLET_PAYOFF_QUOTE_SERVICE_SUBMIT_REQUEST = 'wallet:payoffQuoteService:submit:request';

export const WALLET_PAYOFF_QUOTE_SERVICE_SUBMIT_COMPLETED = 'wallet:payoffQuoteService:submit:completed';

/**
 * requests Wallet Manager to retrieve options from VRS service
 */
export const WALLET_VRS_OPTIONS_REQUEST = 'wallet:vrsOptions:request';

/**
 * an event sent by Wallet Manager with VRS options
 */
export const WALLET_VRS_OPTIONS_COMPLETED = 'wallet:vrsOptions:completed';

/**
 * requests Wallet Manager to get vehicle valuation
 */
export const WALLET_VRS_VEHICLE_VALUATION_REQUEST = 'wallet:vrsVehicleValuation:request';

/**
 * an event sent by Wallet Manager with VRS options
 */
export const WALLET_VRS_VEHICLE_VALUATION_COMPLETED = 'wallet:vrsVehicleValuation:completed';

/**
 * requests Wallet Manager to get inventory payments
 */
export const WALLET_GET_INVENTORY_PAYMENTS_REQUEST = 'wallet:getInventoryPayments:request';

/**
 * an event sent by Wallet Manager with payments data
 */
export const WALLET_GET_INVENTORY_PAYMENTS_COMPLETED = 'wallet:getInventoryPayments:completed';

/**
 * Requests that Wallet Manager create and store a new wallet ID
 */
export const WALLET_CREATE_ID_REQUEST = 'wallet:createWalletId:request';

/**
 * Send completed event upon successfully creating a wallet ID
 */
export const WALLET_CREATE_ID_COMPLETED = 'wallet:createWalletId:completed';

/**
 * Requests Wallet Manager to retrieve nds config data or pass on external config
 */
export const UDS_CONFIG_REQUEST = 'uds:calcConfig:request';

/**
 * Send completed event upon successfully nds config data is retrieved
 */
export const UDS_CONFIG_COMPLETED = 'uds:calcConfig:completed';

/**
 * Requests Wallet Manager to update nds config
 */
export const UDS_CONFIG_UPDATE_REQUEST = 'uds:calcConfigUpdate:request';

/**
 * Send completed event upon successfully nds config data is retrieved
 */
export const UDS_CONFIG_UPDATE_COMPLETED = 'uds:calcConfigUpdate:completed';

/**
 * Send payment calculation response data and deal data upon each nds interaction
 */
export const UDS_PAYMENT_CALC_RESPONSE_UPDATE = 'uds:PaymentCalcResponse:Update';

/**
 * Send payment object updates upon each nds interaction
 */
export const UDS_PAYMENT_OBJ_UPDATE = 'uds:PaymentObject:Update';

/**
 * Send pencil data upon each nds interaction
 */
export const UDS_PENCILING_DATA_UPDATED = 'uds:calcPencilingDataUpdate:updated';

/**
 * Requests payment data update
 */
export const UDS_PAYMENT_UPDATE_REQUEST = 'uds:paymentUpdate:request';

/**
 * Sends route (required) and additional (optional) props to then build the init object and initialize the SDP widget via wallet-manager
 */
export const UDS_OPEN_SDP_REQUEST = 'uds:openSdp:request';

/**
 * Sends name, action, and data from the SDP widget onTrack event
 */
export const UDS_SDP_ONTRACK_COMPLETED = 'uds:sdpOnTrack:completed';

/**
 * Event sent by the external tenant to set the deal type (`finance`, `lease`, `cash`)
 */
export const UDS_SET_DEALTYPE_REQUEST = 'uds:setDealType:request';

/**
 * Event sent by the UDS calculator to indicate that the deal type has been set successfully
 */
export const UDS_SET_DEALTYPE_COMPLETED = 'uds:setDealType:completed';

/**
 * Event sent by the external tenant to retrieve available incentives
 */
export const UDS_GET_INCENTIVES_REQUEST = 'uds:getIncentives:request';

/**
 * Event sent by the UDS calculator when incentives data has been retrieved successfully
 */
export const UDS_GET_INCENTIVES_COMPLETED = 'uds:getIncentives:completed';

/**
 * Event sent by the UDS calculator to request verification of selected payment criteria
 */
export const UDS_CTA_CLICK_REQUEST = 'uds:ctaClick:request';

/**
 * Event sent by the external tenant when the verification of selected payment criteria has been completed
 */
export const UDS_CTA_CLICK_COMPLETED = 'uds:ctaClick:completed';

/**
 * Event sent by the external tenant to trigger opening a Bank of America credit application
 */
export const UDS_OPEN_BOA_CREDIT_APP_REQUEST = 'uds:openBOACreditApp:request';

/**
 * Event sent by the UDS when the Bank of America credit application processing has completed
 */
export const UDS_OPEN_BOA_CREDIT_APP_COMPLETED = 'uds:openBOACreditApp:completed';
